import { Injectable, inject } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

@Injectable({ providedIn: 'root' })
export class SnackbarService {
	private readonly snackBar = inject<MatSnackBar>(MatSnackBar)

	showMessage(message: string, duration: number = 4000): void {
		this.snackBar.open(message, undefined, { duration })
	}

	showErrorMessage(message: string, duration: number = 4000): void {
		this.snackBar.open(message, undefined, { duration, panelClass: 'snackbar-error' })
	}
}
